jQuery(window).on("scroll", function () {
  if (400 < jQuery(this).scrollTop()) {
    jQuery(".site-header").addClass("__cc");
  } else {
    jQuery(".site-header").removeClass("__cc");
  }
});

//brand text
jQuery(function () {
  $("#snow-jewels-japan .collection-grid__item-title.soul-recipe").prepend(
    '<span class="collection-grid__item-subtitle">“Soul Recipes”</span>'
  );
  $(
    "#snow-jewels-japan .collection-grid__item-title.drink-communication"
  ).prepend(
    '<span class="collection-grid__item-subtitle">“Drinking Commune”</span>'
  );
  $(
    "#snow-jewels-japan .collection-grid__item-title.traditional-seasoning"
  ).prepend(
    '<span class="collection-grid__item-subtitle">“Trad Seasoning”</span>'
  );
  $(
    "#snow-jewels-japan .collection-grid__item-title.food-craftmanship"
  ).prepend(
    '<span class="collection-grid__item-subtitle">“Craftsmanship”</span>'
  );
  $("#snow-jewels-japan .collection-grid__item-title.interactive-arts").prepend(
    '<span class="collection-grid__item-subtitle">“Interactive <br>& Experience”</span>'
  );
  $(
    "#snow-jewels-japan .collection-grid__item-title.remix-food-culures"
  ).prepend(
    '<span class="collection-grid__item-subtitle">“Cultures & Souvenir”</span>'
  );
});

jQuery(function () {
  var appear = false;
  var pagetop = $("#page_top");
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      //100pxスクロールしたら
      if (appear == false) {
        appear = true;
        pagetop.stop().animate(
          {
            bottom: "3%", //下から50pxの位置に
          },
          300
        ); //0.3秒かけて現れる
      }
    } else {
      if (appear) {
        appear = false;
        pagetop.stop().animate(
          {
            bottom: "-50px", //下から-50pxの位置に
          },
          300
        ); //0.3秒かけて隠れる
      }
    }
  });
  // pagetop.click(function () {
  //   $("body, html").animate({ scrollTop: 0 }, 500); //0.5秒かけてトップへ戻る
  //   return false;
  // });
});
